import { fromJS } from 'immutable';
import * as cnt from './profile-constants';
import marketReadiness from '../../../utils/marketing-readiness/index.js';
const initialState = fromJS({
  viewingAs: 'unconnected',
});

const checkMarketReadiness = (state) => {
  const marketReadinessResults = marketReadiness('profile', state.toJS());
  const errors = marketReadinessResults.errors;
  const percentage = (state.get('isMarketingReady') === true && errors.length === 0) ? 100 : marketReadinessResults.percentage;
  return state.set('marketingReadinessPercentage', percentage).set('marketingReadinessErrors', errors);
};

export function profile(state = initialState, action) {
  switch (action.type) {
    case 'ADD_LOCATION':
      return state.update('locations', locations => locations.unshift(fromJS({
        id: action.payload.locationId,
        images: [],
        isMarketingReady: false,
        name: action.payload.locationName,
        products: [],
        numOfProducts: 0,
      })));
    case 'GET_USER_LOCATION_PROFILE_STARTED':
    case `${cnt.GET_PROFILE}_STARTED`:
      return state.set('loading', true);
    case 'GET_USER_LOCATION_PROFILE_ERROR':
    case 'GET_USER_LOCATION_PROFILE_SUCCESS':
      return state.set('loading', false);
    case `${cnt.GET_PROFILE}_SUCCESS`:
      return checkMarketReadiness(state.merge(fromJS(action.payload)))
      .set('refresh', false)
      .set('loading', false);
    case 'GET_PROFILE':
      return checkMarketReadiness(state.merge(fromJS(action.profile))).set('refresh', false);
    case `${cnt.UPDATE_GROUP}_STARTED`:
      return state.set('savingGroup', true);
    case `${cnt.DELETE_GROUP}_SUCCESS`:
    case `${cnt.UPDATE_GROUP}_SUCCESS`:
      return state
      .set('manageGroupOpen', false)
      .set('savingGroup', false)
      .set('groupToManage', {});
    case `${cnt.REORDER_PRODUCTS}_STARTED`:
    case `${cnt.REORDER_LOCATIONS}_STARTED`:
      return state.set('savingReorderChanges', true);
    case `${cnt.REORDER_PRODUCTS}_SUCCESS`:
    case `${cnt.REORDER_LOCATIONS}_SUCCESS`:
      return state.set('savingReorderChanges', false)
        .set('reorderItemsOpen', false);
    case `${cnt.REORDER_LOCATIONS}_ERROR`:
      return state.set('savingReorderChanges', false);
    case `${cnt.UPDATE_GROUP}_ERROR`:
      return state.set('savingGroup', false);
    case 'REMOVE_PRODUCT_FROM_PROFILE':
    case 'EDIT_USER_PRODUCT_PROFILE_FIELD':
    case 'REMOVE_LOCATION':
      if (state.isMarketingReady) return state;
      return state.set('refresh', true);
    case 'EDIT_USER_LOCATION_PROFILE_FIELD':
      return state.set('refresh', true);
    case 'PROFILE_IMAGE_CHANGED':
    case 'EDIT_PROFILE_FIELD_STARTING':
      return state.set(action.payload.updateField, action.payload.updateBody);
    case 'DELETE_COVER_IMAGE_FROM_PROFILE':
      return state.set('coverImageUrl', '');
    case 'EDIT_PROFILE_FIELD':
      if (typeof action.payload.isMarketingReady === 'boolean') {
        return checkMarketReadiness(state.set('isMarketingReady', action.payload.isMarketingReady));
      }
      if (typeof action.payload.isLocationMarketingReady === 'boolean') {
        return checkMarketReadiness(state.set('isLocationMarketingReady', action.payload.isLocationMarketingReady));
      }
      return state;
    case 'CLEAR_STORES':
    case 'LOG_OUT':
      return initialState;
    case 'UPDATE_SUPP_PROFILE_PROP':
      return state.merge(fromJS(action.payload));
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/stores/profile/company/profile-reducer.js